import React, { ReactNode } from 'react';

type CheckboxProps = {
    label?: string;
    value: boolean;
    name?: string;
    disabled?: boolean;
    className?: string;
    id?: string;
    renderLabel?:() => string | ReactNode;
    onChange(checked: any): void;
};

const Checkbox: React.FC<CheckboxProps> = ({ label, renderLabel, onChange, value, name, disabled, className, id }) => (
    <div className={['checkbox-container', className].join(' ')}>
        <label className="pure-material-checkbox">
            <input
                type="checkbox"
                name={name}
                onChange={onChange}
                checked={value}
                disabled={disabled || false}
                id={id || ""}
            />

            <span/>
        </label>
        <div className="checkbox-text">{ renderLabel ? renderLabel() : label }</div>
    </div>
);


export default Checkbox;
